export default __webpack_public_path__ + "static/media/password_generator.aa25cbf8.png";